import Vue from 'vue'
import { $isInIos } from '@/util/util'
import store from '@/store/index'

(function () {
  window.eventBus = new Vue()// 注册全局事件对象

  // H5内购支付成功回调
  let myProdPayed
  let myIsPopBuy

  window.eventBus.$on('payInH5', (prodPayed, isPopBuy) => {
    myProdPayed = prodPayed
    myIsPopBuy = isPopBuy
  })

  /**
   * 支付结果回调
   * @param {*} isSuccess 
   * @returns 
   */
  window.onPayResult = (isSuccess) => {
    if (!isSuccess) {
      Vue.prototype.$sensors.track('app_page_click', {
        click_result: 'fail'
      })
      return
    }

    store.commit('SET_FINISH_PAY_ACTION')

    Vue.prototype.$sensors.track(myIsPopBuy ? 'app_popup_click_result' : 'app_member_result', {
      payment_amount: myProdPayed.totalPrice,
      button_name: myProdPayed.description
    })
    Vue.prototype.$sensors.track('app_page_click', {
      click_result: 'success'
    })
    Vue.prototype.$toast('您已获得奖励，快去查看吧')
    window.eventBus.$emit('refreshAfterPay')
  }

  /**
   * APP：分享结果回调
   * 
   * onShareResultByApp(JSON.stringify({result: 'success'}))
   */
  window.onShareResultByApp = (message) => {
    message = JSON.parse(message)
    // 安卓QQ返回app会上报失败
    if (message.result == 'success' || (!$isInIos() && message.type === 'qq' && message.result === 'cancle')) {
      // 分享成功
      window.eventBus.$emit('onTaskResult', true, store.state.shareInTaskId)
      window.eventBus.$emit('onCouponResult', true, store.state.shareInCouponId)
    } else {
      // 分享失败
      window.eventBus.$emit('onTaskResult', false)
      window.eventBus.$emit('onCouponResult', false)
    }
  }

  
  /**
   * 激励视频doTask的客户端回调
   *
   * @param {*} jsonStr {"taskId":"30203208-a515-4fe4-a707-e0b48ecfb583","actionType":1,"success":true}
   */
    window.onUserTaskReported = (jsonStr) => {
      console.log(`onUserTaskReported 回调结果：${jsonStr}`)

      const result = JSON.parse(jsonStr)

      if (result.success) {
        console.log('激励视频回调成功')
        window.eventBus.$emit('refresh')
      } else {
        window.eventBus.$emit('refresh')
        Vue.prototype.$toast('视频观看失败')
      }
    }

  /**
   * token发生变化，如登录和退登 // android处理
   * 
   */
  window.onTokenChanged = () => {
    window.eventBus.$emit('tokenChanged')
  }
  window.triggerPhysicalBack = () => {
    // 触发客户端物理返回
    window.eventBus.$emit('onWebviewBack')
  }
})()
